module.exports = __webpack_public_path__ + "img/ds820.f3fbd075.jpg";